import Vue from 'vue';
import Router from 'vue-router';
import { getRouter } from "@/router/router.js";
// 启用路由
Vue.use(Router);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
    hidden: true,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/reloadPage',
    name: 'reload-page',
    component: () => import("@/views/reload.vue")
  }
]


const router = new Router({
  mode: "hash",
  routes,
});

// 路由拦截器
router.beforeEach((to, from, next) => {
  if(to.name != 'login' && to.name != 'loginSSO'){ //如果不是登录页面
    if(localStorage.getItem('userInfo')){
      if(routes.length < 4){
        let menuList = localStorage.getItem('menuList')
        if(menuList){
          let menu = JSON.parse(menuList)
          const newRoutes = routes;
          Promise.all([getRouter(menu, newRoutes)]).then((result) => {
            const newRouter = new Router({
              mode: "hash",
              routes: result[0],
            });
            router.matcher = newRouter.matcher;
            router.push({ path: to.path})
          });
        }
      }else {
        next()
      }
    }   //已登录就执行跳转
    else next({name:'login'})   //否则跳转到登录页面
  }else{ //如果是登录页面
    if(to.name == 'login' && to.query.t == 'd'){
      localStorage.setItem('authToken','')
      localStorage.setItem('userInfo','')
      next()
    }else if(to.name == 'loginSSO'){
      next()
    }else {
      if(localStorage.getItem('userInfo'))next({path:'/home'}) //已登录就跳转到首页
      else  next()  //否则正常进入登录页面
    }
  }
})
export default router;
export {
  routes
}



// WEBPACK FOOTER //
// ./src/router/index.js